import React from 'react';
import {
  CreateBase,
} from 'react-admin';

import { permissionRoleCleaner } from '../../utilities/dataProvider/cleaner';
import PermissionRolesForm from './PermissionRolesForm';

const PermissionRolesCreate = ({
  setSelectedRole,
}: {
  setSelectedRole: (newRole: string | undefined) => void;
}) => (
  <CreateBase
    transform={permissionRoleCleaner}
    mutationOptions={{ onSuccess: (response: any) => setSelectedRole(response.id) }}
    mutationMode="pessimistic"
  >
    <PermissionRolesForm mode="create" onCancel={() => setSelectedRole(undefined)} />
  </CreateBase>
);

export default PermissionRolesCreate;
